

















import Vue from 'vue'
import { ProfileInputElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ProfileInputEl',
  props: {
    templateItemData: {
      type: Object as () => ProfileInputElInterface,
      required: true
    }
  },
  data () {
    return {
      nickname: '',
      rules: {
        counter: (value: string) => value.length <= this.templateItemData.maxChar || 'Najviše ' + this.templateItemData.maxChar + ' karaktera'
      }
    }
  },
  created () {
    this.nickname = this.templateItemData.value
  }
})
